<ion-list>
  <!-- SNIPPET:START:KonditionText -->
  <!-- SNIPPET:END -->
  <ion-item *ngFor="let k of konditionen" (click)="select(k);">
    <ion-icon slot="start" [name]="k.name === kondition.name ? 'checkbox-outline' : 'square-outline'"></ion-icon>
    <ion-label>
      <h2>{{k.name}}</h2>
      <p *ngIf="config.anzeigetyp !== 'Segler'">Lieferort: {{k.lieferort}}</p>
      <p>Abr.: {{k.abrechnungName}}</p>
    </ion-label>
  </ion-item>
</ion-list>